import { getPreviewComponent } from '../file-preview/renderElements';
import type { FC } from 'react';

interface Props {
  url: string;
  extName: string;
}

export const Preview: FC<Props> = (props) => {
  const Element = getPreviewComponent(props.extName);
  return <Element uuid={''} downloadUrl={props.url} />;
};
